import React, { useState, useEffect } from 'react';
import { useFavouriteQuestionsAtom } from '../../atoms/useFavouriteQuestionsAtom';
import { useSelectedTabAtom } from '../../atoms/useSelectedTabAtom';
import { saveFavouriteQuestion, getFavouriteQuestions } from '../../api/questionAPIs';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { isStoppingAtom } from '../../atoms/useIsStoppingAtom';
import { selectedEnvironmentAtom } from '../../atoms/useSelectedEnvironmentAtom';
import {MessageTypeEnum} from "../../enums/MessageTypeEnum";

import MessageTable from './MessageTable';
import MessageChart from './MessageChart';
import MessageSourceModal from './MessageSourceModal';
import MessageRating from './MessageRating';
import useAuth from "../../hooks/useAuth";

const MessageBubble = (props) => {
  const { auth } = useAuth();
  let userName = auth.ufn;
  const [isStopping, setIsStopping] = useAtom(isStoppingAtom);
  const [selectedEnvironment, ] = useAtom(selectedEnvironmentAtom);
  const [, setFavQuestions] = useFavouriteQuestionsAtom();
  const [selectedTab] = useSelectedTabAtom();
  const [t, ] = useTranslation('global');
  const [sourcesAvailable, setSourcesAvailable] = useState(true);
  const [showSources, setShowSources] = useState(false);
  
  const toggleSources = () => {
    setShowSources(!showSources);
  };

  const handleIconClick = () => {
    saveFavouriteQuestion(selectedTab, props.message, selectedEnvironment)
    .then(() => {
      var questions = getFavouriteQuestions(selectedTab);
      setFavQuestions(questions);
    })
  };

  useEffect(() => {
    if (props.meta && props.meta.length === 0) {
      setSourcesAvailable(false);
    }
  }, []);

  useEffect(() => {
    if (props.type === 'stopped') {
      setIsStopping(false);
    }
  }, [props.type]);

  return (
    <>
      <div className={`msg ${props.role === 'assistant' ? 'left-msg' : 'right-msg'}`}>
        <div>
          <img
            alt={props.role}
            src={props.role === 'assistant' ? props.bot : props.avatar}
            className="msg-img"
          />
        </div>

        <div className="msg-bubble">
          {props.type !== 'loading' ? (
            <div className="msg-info">
              <div className="msg-info-name">
                {props.role === 'assistant' ? 'Millada' : props.role === 'user' ? userName : null}
              </div>
              {/* <div className="msg-favorite" onClick={handleIconClick}>
                {props.role === 'assistant' ? null : <span className="material-symbols-outlined">add_circle</span>}
              </div> */}
              <div className="msg-info-time">{props.sent}</div>
            </div>
          ) : null}
          {props.type === 0 ? (
            props.message
          ) : props.type === 1 ? (
            <MessageTable id={props.id} columns={props.message.Columns} rows={props.message.Rows} />
          ) : props.type === 2 ? (
            <MessageChart id={props.id} json={props.message} /> 
          ): props.type === 3 ? (           
            <>
            <div className="msg-text-container">
              <div className="msg-text">
                 { props.message }
              </div>
            </div>          
            {sourcesAvailable && (
              <>
              <div className="show-sources">
                <span className={showSources ? "material-symbols-outlined show-sources-icon rotate0 rotate180" : "material-symbols-outlined show-sources-icon rotate0"} onClick={toggleSources}>
                  keyboard_arrow_down
                </span>
              </div>
              <div className={showSources ? "sources-list height0 height8em" : "sources-list height0"}>
                {showSources && (
                  props.meta.map((source, index) => 
                    <div className='msg-source-item' key={index}>
                        <MessageSourceModal meta={{
                          f: source.Metadata.f,
                          n: source.Metadata.n,
                          p: source.Metadata.p,
                          c: source.Chunk
                        }}/>
                    </div>
                ))}
              </div>
              </>
            )}            
            <MessageRating id={props.messageId} />
            </>
          ) : props.type === MessageTypeEnum.Loading ? (
            <div className="msg-text">
              <div className="typing">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : props.type === 'stopping' ? (
            <div className="msg-text">
              <div className="stopped">
                <span>Response cancelled.</span>
                <span></span>
                <span></span>
              </div>
            </div>
          ) : null }
        </div>
      </div>
    </>
  );
};

export default MessageBubble;
